import { render, staticRenderFns } from "./VAutocompleteRoles.vue?vue&type=template&id=6d1012b8&scoped=true"
import script from "./VAutocompleteRoles.vue?vue&type=script&lang=js"
export * from "./VAutocompleteRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1012b8",
  null
  
)

export default component.exports